import React, { Children } from 'react';
import { TransitionGroup } from 'react-transition-group';
import AnimateGroupChild from './AnimateGroupChild';

function AnimateGroup(props) {
  var component = props.component,
      children = props.children,
      appear = props.appear,
      enter = props.enter,
      leave = props.leave;
  return React.createElement(TransitionGroup, {
    component: component
  }, Children.map(children, function (child, index) {
    return React.createElement(AnimateGroupChild, {
      appearOptions: appear,
      enterOptions: enter,
      leaveOptions: leave,
      key: "child-".concat(index)
    }, child);
  }));
}

AnimateGroup.defaultProps = {
  component: 'span'
};
export default AnimateGroup;